module.exports = __webpack_public_path__ + "img/index-rcfw3.78ed2898.png";